export default class ContentContext {
  private name: string;
  private image: string;
  private id: string;
  private type: string;
  private group: string;

  constructor(name: string, image: string, id: string, type: string, group: string) {
    this.name = name;
    this.image = image;
    this.id = id;
    this.type = type;
    this.group = group;
  }

  clone() {
    return new ContentContext(this.name, this.image, this.id, this.type, this.group);
  }

  getName() {
    return this.name;
  }

  getImage() {
    return this.image;
  }

  getType() {
    return this.type;
  }

  getId() {
    return this.id;
  }

  getGroup() {
    return this.group;
  }
}
